<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  contact: { type: Object, required: true },
});

const emit = defineEmits(['select']);
const { t } = useI18n();

const initials = computed(() => {
  const name = props.contact.name || props.contact.email || '?';
  return name
    .trim()
    .split(' ')
    .map(w => w[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
});
</script>

<template>
  <div
    class="flex items-center gap-3 p-3 rounded-lg bg-n-solid-1 border border-n-weak cursor-pointer hover:border-n-strong"
    @click="emit('select', contact)"
  >
    <img
      v-if="contact.thumbnail"
      :src="contact.thumbnail"
      :alt="contact.name"
      class="size-8 rounded-full object-cover flex-shrink-0"
    />
    <div
      v-else
      class="flex items-center justify-center size-8 rounded-full bg-n-brand/10 text-n-brand text-xs font-semibold flex-shrink-0"
    >
      {{ initials }}
    </div>
    <div class="flex flex-col min-w-0">
      <span class="text-sm font-medium text-n-slate-12 truncate">
        {{ contact.name || t('KANBAN.CARD.NO_NAME') }}
      </span>
      <span v-if="contact.email" class="text-xs text-n-slate-10 truncate">
        {{ contact.email }}
      </span>
    </div>
  </div>
</template>
